import * as React from 'react';
import { useEffect, ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormInput } from '@enginuity-apps-ui-components/molecules/form-elements/form-input/form-input';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';
import { ErrorList, IErrorList } from '@enginuity-apps-ui-components/molecules/form-elements/error-list/error-list';
import { PasswordVerifierPanel } from '@enginuity-apps-ui-components/molecules/form-elements/password-verifier-panel/password-verifier-panel';
import { ErrorPanel } from '@enginuity-apps-ui-components/atoms/error-panel/error-panel';


export type ISetPasswordFormData = {
  password: string;
  confirmPassword: string;
};

export type ISetPasswordContent = {
  title?: string;
  buttonText?: string;
};

export type ISetPasswordProps = {
  onSubmit: (data: ISetPasswordFormData) => void;
  username: string;
  apiErrors?: any;
  setPasswordContent?: ISetPasswordContent;
};

export default function SetPassword({ onSubmit, username, apiErrors, setPasswordContent }: ISetPasswordProps) {
  const { register, handleSubmit, errors, getValues } = useForm();
  const [password, setPassword] = useState<string>("");
  const [passwordIsValid, setPasswordIsValid] = useState<boolean>(false);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPassword(event.currentTarget.value);
  }

  return (
    <div className="container  ">
      <div className="row md-spacer-80 spacer-32">
        <div className="col-lg-1"></div>
        <div className="col-lg-11">
          <h1>Set password</h1>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row md-spacer-32 spacer-72">
          <div className="col-lg-2"></div>
          <div className="col-lg-6">
            {!setPasswordContent || setPasswordContent.title &&
              <div className="row no-spacer">
                <div className="col-lg-12">
                  <h3 className="color-malachite-green">{setPasswordContent?.title ? setPasswordContent?.title : "05. Password"}</h3>
                </div>
              </div>
            }
            <div className="row spacer-32">
              <div className="col-lg-6">
                <FormInput
                  label={<>Password *</>}
                  id="password"
                  type="password"
                  onChange={onChange}
                  defaultValue=""
                  ref={register({
                    required: "Please enter your new password.", maxLength: {
                      value: 50, message: 'Password cannot be more than 50 characters'
                    },
                    validate: value => passwordIsValid || 'Password does not meet requirements'
                  })}
                  errors={errors}
                />
              </div>
              <div className="col-lg-6 lg-no-spacer spacer-16">
                <FormInput
                  label={<>Confirm your password *</>}
                  id="confirmPassword"
                  type="password"
                  defaultValue=""
                  ref={register({
                    required: "Please confirm your new password.", maxLength: {
                      value: 50, message: 'Password cannot be more than 50 characters'
                    },
                    validate: value => value === password || 'Passwords must match'
                  })}
                  errors={errors}
                />
              </div>
            </div>
            <div className="row spacer-16">
              <div className="col-lg-12">
                <p className="required-field-text color-purple-grey">* indicates required field</p>
              </div>
            </div>
            <div className="row spacer-12">
              <div className="col-lg-10">
                <ErrorList errors={errors}>We found some errors. Please review the form and make the corrections.</ErrorList>
                {apiErrors && (
                  <ErrorPanel>{apiErrors}</ErrorPanel>
                )}
              </div>
            </div>
            <div className="row spacer-32">
              <div className="col-lg-12">
                <Button buttonType="button" type="submit" className="cmp-button--primary">{setPasswordContent?.buttonText ? setPasswordContent?.buttonText : "Activate my account"}</Button>
              </div>
            </div>
          </div>
          <div className="col-lg-4 why-collect-data-panel">
            <PasswordVerifierPanel title={"How to create a strong password"} password={password} username={username} isValid={(val: boolean) => setPasswordIsValid(val)}>
            </PasswordVerifierPanel>
          </div>
        </div>
        <div className="row spacer-32">
        </div>
      </form>
    </div>
  );
}
